import EntityModel from '@/common/models/entity-model';

export default class CouponRedemptionModel extends EntityModel {
    hydrate({
        redemptionCode = null,
        customerId = null,
        additionalRestrictions = [],
    } = {}) {
        this.redemptionCode = redemptionCode;
        this.customerId = customerId;
        this.additionalRestrictions = additionalRestrictions;
    }

    getPayload() {
        return {
            redemptionCode: this.redemptionCode,
            customerId: this.customerId,
            additionalRestrictions: this.additionalRestrictions,
        };
    }
}
